import { render } from "./FileAnswer.vue?vue&type=template&id=65dee3e7"
import script from "./FileAnswer.vue?vue&type=script&lang=js"
export * from "./FileAnswer.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__